import { render } from "./AddOwner.vue?vue&type=template&id=0545a19c&scoped=true"
import script from "./AddOwner.vue?vue&type=script&lang=js"
export * from "./AddOwner.vue?vue&type=script&lang=js"

import "./AddOwner.vue?vue&type=style&index=0&id=0545a19c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0545a19c"]])

export default __exports__